import { writable } from "svelte/store"
/**
 * @type {fileTemplateState}
 */
let storedFileTempState = localStorage.getItem("P2BFileTempEditor")
// null

if (typeof storedFileTempState != "Object") {
  try {
    storedFileTempState = JSON.parse(storedFileTempState)
    if (!storedFileTempState) {
      throw new Error("storedFileTempState value is null")
    }
  } catch (error) {
    storedFileTempState = {
      documentTemplateId: undefined,
      documentTempName: "None",
      baseImageUploadModal: true,
      runWatcher: false,
      baseImageInfo: {},
      fonts: [],
      activeFontFamily: "Arial",
      activeFontSize: 65,
      activeTextAlign: "center",
      activeTextColor: "#f2072e",
      activeFontStyles: [],
      operations: [],
      download: false,
      canvasScale: 0,
      canvasHeight: 0,
      parsedJson: {},
      tempOperation: [],
      templateDel: false,
      apiFonts: [],
      goBack: false,
      showImageSection: false,
      scale: 1,
      notifyFooter: "",
      footerArray: ["You can change the quality in settings", "Add or Edit, Text, Image and qr elements", "You can Add custom fonts for text layers", "You can Able to change File template name", "Able to Download the canvas"],
    }
  }
}

/**
 * @typedef {Object} baseImageInfoList - base image's information
 * @type {Object}
 * base image's information
 * @property {String} name - base image's name
 * @property {Array<String>} palette - base image's color palette
 * @property {Number} size - base image's size in bytes
 * @property {Number} width - base image's width in pixels
 * @property {Number} height - base image's height in pixels
 * @property {String} uri - base image's url
 * @property {String} uploadedTime - base image's uploaded time
 * @property {Number} Quality - base image's quality 0 t 100
 * @property {Number} rangeValue - base image's range 0 t 100
 * @property {Number} id - unique id for uploaded image
 */

/**
 * @typedef {Object} OperationLayersItem - details of operations
 * @type {Object}
 * operations's information
 *
 * @property {"image" | "text" | "qr"} type - uploaded layer's type
 * @property {String} attribute - to display the attribute name
 * @property {Number} inputY - to display the cursor 0,0 bottom postion
 * @property {Boolean} active - card displayed state
 * @property {Boolean} hover - while hovering background clr added
 * @property {Number} width - image's weight
 * @property {Number} height - image's height
 * @property {HTMLImageElement} image - image's link src
 * @property {String} value - text layer's value
 * @property {String} fontFamily - text layer's font family
 * @property {String} src - to display the sub image
 * @property {Number} fontSize - text layer's font size
 * @property {Array<String>} fontStyles - text layer's font styles
 * @property {String} textColor - text layer's font color
 * @property {"left" | "center" | "right"} textAlign - text layer's font alignment
 * @property {Number} x - image or text layer x coordination
 * @property {Number} y - image or text layer y coordination
 * @property {boolean} move - to display the cursor position
 * @property {true | false} maintainAspectRatio - maintain or give up image's width and height aspect radio
 * @property {Number} aspectRatio - aspect ratio of the image
 * @property {true | false} dynamic - maintain image's static and dynamic
 * @property {Boolean} uploadImage - subImage uploaded

 */

/**
 * @typedef {Object} fileTemplateState - it contains the base image, added font layers & operations information
 * @type {Object}
 *  it contains the base image, added font layers & operations information
 *
 * @property {String} documentTemplateId - select document template while uploading base image
 * @property {String} documentTempName - selected document template name while uploading base image
 * @property {boolean} baseImageUploadModal - base image upload modal
 * @property {boolean} runWatcher - draw canvas using this variable
 * @property {baseImageInfoList} baseImageInfo - base image's information
 * @property {Array<String>} fonts - list of font layer's id
 * @property {Array<OperationLayersItem>} operations - list of operations's information
 * @property {Array<String>} apiFonts - choosing new font from checkbox
 * @property {boolean} canvasScale - using text and cursorPosition in sameAlignment
 * @property {boolean} canvasHeight - to get clientHeight using canvasHeight
 * @property {Boolean} download - finally download the image or certificate.
 * @property {String} activeFontFamily - to display active font family
 * @property {Number} activeFontSize - to display active font Size
 * @property {String} activeTextAlign - to display active text align
 * @property {String} activeTextColor - to display active text colour
 * @property {Array} activeFontStyles - to display active text Style
 * @property {Object} parsedJson - Parsed document template metadata.
 * @property {Array} tempOperation - to store old operation value.
 * @property {Boolean} templateDel - to delete overAll template.
 * @property {Number} activeId - to find current layer
 * @property {Boolean} showImageSection - toggling to show and hide the image section
 * @property {Boolean} goBack - to go list page
 * @property {Boolean} scale - to get a scale value
 * @property {String} notifyFooter - to display every action in notification msg
 */

/**
 * @type {import("svelte/store").Writable<fileTemplateState>}
 */
const fileTemplateState = writable(storedFileTempState)

export default fileTemplateState
